export default __webpack_public_path__ + "static/media/innertrends-logo-color.531c4eeb.svg";